var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTallasızekıds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_2",
    "data-name": "katman 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 107.72 29.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "katman_1",
    "data-name": "katman 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 107.72,
    y1: 6.55,
    x2: 0,
    y2: 6.55,
    fill: "none",
    stroke: "#1d1d1b",
    strokeMiterlimit: 10,
    strokeWidth: ".25px"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 107.72,
    y1: 28.97,
    x2: 0,
    y2: 28.97,
    fill: "none",
    stroke: "#1d1d1b",
    strokeMiterlimit: 10,
    strokeWidth: ".25px"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTallasızekıds);
export default __webpack_public_path__ + "static/media/TALLASIZEKIDS.823862337f9cd76fc685192cdb65b10d.svg";
export { ForwardRef as ReactComponent };